import type { JSX } from 'react';
import { Alert, AlertTitle, List, ListItem, ListItemText, Typography } from '@mui/material';

/**
 * Seção que depende de configuração externa. Em vez de mostrar tela vazia ou
 * dado inventado, o painel diz exatamente o que falta — é a diferença entre
 * "não implementado", "bloqueado por credencial" e "sem dado ainda".
 */
export function ConfigSection({
  title,
  description,
  blockedBy,
  planned,
}: {
  title: string;
  description: string;
  blockedBy: string[];
  planned: string[];
}): JSX.Element {
  return (
    <>
      <Typography variant="h1" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {description}
      </Typography>
      <Alert severity="warning" sx={{ mb: 3 }}>
        <AlertTitle>Indisponível nesta revisão</AlertTitle>
        Esta área depende de código ainda não implementado ou de credencial externa. O painel
        prefere declarar o bloqueio a exibir dado fictício.
      </Alert>
      <Typography variant="h2" gutterBottom>
        Bloqueado por
      </Typography>
      <List dense>
        {blockedBy.map((item) => (
          <ListItem key={item} disableGutters>
            <ListItemText primary={item} />
          </ListItem>
        ))}
      </List>
      <Typography variant="h2" gutterBottom sx={{ mt: 2 }}>
        Previsto no plano
      </Typography>
      <List dense>
        {planned.map((item) => (
          <ListItem key={item} disableGutters>
            <ListItemText primary={item} />
          </ListItem>
        ))}
      </List>
    </>
  );
}